import React, { useState } from "react";
import { MODEL } from "../../model";

const About = () => {
  const [showAU, setShowAU] = useState(false);
  const [showWCU, setShowWCU] = useState(false);

  const handleToggle = () => {
    setShowAU(!showAU);
  };

  const handleWCUToggle = () => {
    setShowWCU(!showWCU);
  };

  return (
    <section id="about" className="about">
      <div className="about__content">
        <h2>{MODEL.data.about_us.heading}</h2>
        <p>{MODEL.data.about_us.intro}</p>

        {MODEL.data.about_us.sections.map((section, index) => {
          // const isVisible = showAU || index === 0; // Only show first section when collapsed
          const isVisible = showAU; // Only show first section when collapsed
          return (
            <div key={index} className={`content ${isVisible ? "show" : ""}`}>
              <h3>{section.title}</h3>
              <p>{section.content}</p>
            </div>
          );
        })}

        <button className="btn" onClick={handleToggle}>
          {showAU ? "Hide" : "Read More"}
        </button>
      </div>

      <div className="about__content">
        <h2>{MODEL.data.join_us.heading}</h2>
        <p>{MODEL.data.join_us.intro}</p>

        {MODEL.data.join_us.sections.map((section, index) => {
          // Show only the first section when not expanded
          // if (!showWCU && index > 0) return null;
          // const isVisible = showWCU || index === 0;
          const isVisible = showWCU;
          return (
            <div key={index} className={`content ${isVisible ? "show" : ""}`}>
              <h3>{section.title}</h3>
              <p>{section.content}</p>
            </div>
          );
        })}

        <button className="btn" onClick={handleWCUToggle}>
          {showWCU ? "Hide" : "Read More"}
        </button>
      </div>
    </section>
  );
};

export default About;
